<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-select
          label="Status"
          :items="statusOptions"
          v-model="statusFilter"
          item-text="text"
          item-value="value"
          dense
          outlined></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Número"
          v-model="query"
          @click:append="search()"
          append-icon="mdi-magnify"
          v-on:keyup.enter="search()"
          dense
          outlined></v-text-field>
      </v-col>
      <v-col>
        <v-alert dense text type="info">
          {{ filtered.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="accent" @click="report()" block title="Relatórios">
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Número</th>
          <th>Cliente</th>
          <th>Plano</th>
          <th>Status</th>
          <th>Canais</th>
          <th>Mensalidade</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filtered" :key="item.id">
          <td>{{ item.number }}</td>
          <td>{{ item.clientName }}</td>
          <td>{{ item.planName }}</td>
          <td><v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip></td>
          <td>{{ item.channels }}</td>
          <td>R$ {{ item.monthly }}</td>
          <td>
            <v-btn icon :to="'/call/' + item.id" title="Chamadas"><v-icon>mdi-file-phone</v-icon></v-btn>
            <v-btn icon :to="'/sipline/' + item.id" title="Detalhes"><v-icon>mdi-magnify</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: [],
    statusFilter: 0,
    statusOptions: [
      { value: null, text: "Todos" },
      { value: 0, text: "Habilitado" },
      { value: 1, text: "Bloqueio administrador" },
      { value: 2, text: "Bloqueio cliente" },
      { value: 3, text: "Bloqueio pagamento" },
      { value: 4, text: "Cancelado" }
    ],
    query: "",
    dialog_loading: false
  }),
  computed: {
    filtered: function() {
      if (this.statusFilter === null) {
        return this.current;
      }
      return this.current.filter(item => item.status == this.statusFilter);
    }
  },
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/sipline", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar listagem!");
      });
    },
    register: function (){
      router.push({path: "/sipline/new"});
    },
    details: function (item){
      router.push({path: "/sipline/"+item.id});
    },
    calls: function (item){
      router.push({path: "/call/"+item.id});
    },
    report: function (){
      router.push({path: "/sipline/report"});
    },
    search: function() {
      var me = this;
      if(me.query==""){
        this.list();
        return;
      }
      if(me.query.length<2){
        alert("A busca precisa ter pelo menos 2 caracteres!");
        return;
      }
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/sipline/number/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao realizar busca!");
        });
    },
    colorStatus: function(item){
      var color = "default";
      if (item.status==0){
        color = "success";
      }else if (item.status==1){
        color = "warning";
      }else if(item.status==2){
        color = "info";
      }else if(item.status==3){
        color = "error";
      }else if(item.status==4){
        color = "secondary";
      }
      return color;
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "Desconhecido";
      if (item.status==0){
        text = "Habilitado";
      }else if (item.status==1){
        text = "Bloqueio administrador";
      }else if(item.status==2){
        text = "Bloqueio cliente";
      }else if(item.status==3){
        text = "Bloqueio pagamento";
      }else if(item.status==4){
        text = "Cancelado";
      }
      return text;
    }
  }
};
</script>